import { AlephaError } from "alepha";

export class CacheError extends AlephaError {}
